// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"automatic_notes-module_wrapper_bddb0","title":"automatic_notes-module_title_af5a4","text":"automatic_notes-module_text_e9557"};